interface Props {
  onClick: (e: React.MouseEvent<SVGElement, MouseEvent>) => void;
  dim?: number;
}
const SvgEdit: React.FC<Props> = ({ onClick, dim = 24 }) => {
  return (
    <svg
      style={{ cursor: "pointer" }}
      onClick={onClick}
      width={dim}
      height={dim}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15597_7081)">
        <path
          d="M18.1723 9.69855L19.1997 8.67111C20.2668 7.60407 20.2668 5.86752 19.1997 4.80006C18.6831 4.28381 17.9963 4 17.2641 4C16.5318 4 15.8446 4.28423 15.3284 4.80048L14.3014 5.82751L18.1723 9.69855ZM13.4083 6.72064L5.79987 14.3292C5.63776 14.4914 5.51438 14.6914 5.4428 14.9082L4.0322 19.17C3.95682 19.3966 4.0162 19.6463 4.18505 19.8151C4.3059 19.9356 4.46675 20 4.63181 20C4.69834 20 4.76529 19.9895 4.83056 19.968L9.09099 18.5569C9.30869 18.4854 9.50912 18.362 9.67124 18.1994L17.2792 10.5913L13.4083 6.72064Z"
          className="fill-primary"
        />
      </g>
      <defs>
        <clipPath id="clip0_15597_7081">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgEdit;
